import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import left_arrow from '../../assets/images/left-arrow.png';
import right_arrow from '../../assets/images/right-arrow.png';
import RazProgressSVG from '../../components/UI/SVG_IMGs/RazProgressSVG';
import { getActiveThemeColor } from "../../utils/utils";
import { PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT_VERBOSE } from "../../utils/constants";
import SlideImage from '../../assets/images/graphicImage.png'
import '../../assets/css/program_preview.page.css';

const ProgramPreviewPage = () => {
    const programData = {
        course_name: "Cognitive Enhancement Program"
    };

    const sessionData = {
        lesson_title: 'Session 1: Define and Identify Digital Footprint Elements',
        slides: [
            {
                SlideLayout: "Introduction_title_with_goals",
                SlideTitle: "Welcome & Lesson Goals",
                SlideContent: [
                    {
                        PointTitle: "Understand Digital Footprints",
                        PointText: "Learn the definition and elements that form a digital footprint."
                    },
                    {
                        PointTitle: "Explore Online Activities",
                        PointText: "Identify how everyday online actions shape your digital presence."
                    },
                    {
                        PointTitle: "Active vs Passive Footprints",
                        PointText: "Differentiate between intentionally shared content and automatically recorded data."
                    }
                ],
                Images: [],
            },

            {
                SlideLayout: "content_title_with_image",
                SlideTitle: "Can You Trust It? Learning to Fact-Check!",
                SlideContent: [],
                Images: [SlideImage]
            },

            {
                SlideLayout: "content_title_with_description",
                SlideTitle: "Welcome!",
                SlideContent: "Are you ready to find out what's real and what's not online? Sometimes the internet tells the truth. But sometimes it doesn't!\nToday, you'll learn how to tell the difference. Let's go!",
                Images: [],
            },

            {
                SlideLayout: "content_single_point_with_1_image",
                SlideTitle: "Know That Not Everything Online Is True",
                SlideContent: "Are you ready to find out what's real and what's not online? Sometimes the internet tells the truth. But sometimes it doesn't!\nToday, you'll learn how to tell the difference. Let's go!",
                Images: [SlideImage]
            },

            {
                SlideLayout: "content_with_image_and_list",
                SlideTitle: "Know That Not Everything Online Is True",
                SlideContent: [
                    "Here are the main types of digital footprints you leave online:",
                    [
                        "Is it true?",
                        "Is it helpful?",
                        "Could it hurt someone?"
                    ],
                    "Remember: Your digital footprint can last forever online!"
                ],
                Images: [SlideImage]
            },
            {
                SlideLayout: "content_title_with_list",
                SlideTitle: "Icebreaker: Real or Not?",
                SlideContent: [
                    "Search history and queries recorded by search engines.",
                    "Transactional records and purchase data from e-commerce sites.",
                    "Automatically gathered data from various website visits."
                ],
                Images: [],
            },

            {
                SlideLayout: "content_description_with_no_image",
                SlideTitle: "What is a Digital Footprint?",
                SlideContent: "A digital footprint comprises all the traces we leave behind online, including comments, posts, messages, and search history. It represents the online identity built through personal interactions.",
                Images: []
            },

            {
                SlideLayout: "content_3_points_with_no_image",
                SlideTitle: "Types of Digital Footprints",
                SlideContent: [
                    {
                        PointTitle: "Active Footprint",
                        PointText: "Data you intentionally share (social media posts, comments)"
                    },
                    {
                        PointTitle: "Passive Footprint",
                        PointText: "Data collected without direct input (cookies, browsing history)"
                    },
                    {
                        PointTitle: "Public Records",
                        PointText: "Government documents, court records available online"
                    }
                ],
                Images: []
            },

            {
                SlideLayout: "content_with_image_and_list",
                SlideTitle: "Know That Not Everything Online Is True",
                SlideContent: [
                    "Just because something is:",
                    [
                        "Viral",
                        "Popular",
                        "Or posted by someone you follow…"
                    ],
                    "doesn’t mean it’s true.",
                    [
                        "Anyone can post anything—real or fake."
                    ],
                ],
                Images: []
            },

            {
                SlideLayout: "content_title",
                SlideTitle: "The Day Jordan Shared the Mermaid Post",
                SlideContent: [],
                Images: []
            },

            {
                SlideLayout: "content_with_right_image_and_list",
                SlideTitle: "",
                SlideContent: [
                    "Just because something is:",
                    [
                        "Viral",
                        "Popular",
                        "Or posted by someone you follow…"
                    ],
                    "doesn’t mean it’s true.",
                    [
                        "Anyone can post anything—real or fake."
                    ],
                ],
                Images: [SlideImage]
            },

            {
                SlideLayout: "content_with_image_and_list",
                SlideTitle: "",
                SlideContent: [
                    "Just because something is:",
                    [
                        "Viral",
                        "Popular",
                        "Or posted by someone you follow…"
                    ],
                    "doesn’t mean it’s true.",
                    [
                        "Anyone can post anything—real or fake."
                    ],
                ],
                Images: [SlideImage]
            },
            {
                SlideLayout: "content_image_with_lists",
                SlideTitle: "",
                SlideContent: [
                    "Here’s what Jordan learned:",
                    [
                        "Not everything you see online is real.",
                        ["Anyone can post anything—even stuff that’s totally made up."],
                        "Some things are made to trick you.",
                        ["Anyone can post anything—even stuff that’s totally made up."],
                        "It’s easy to check before you believe.",
                        ["Anyone can post anything—even stuff that’s totally made up."],
                    ],
                ],
                Images: [SlideImage]
            },
            {
                SlideLayout: "content_description_with_no_image",
                SlideTitle: "Step 1: Read this Scenario Carefully",
                SlideContent: [
                    "You are scrolling through your feed and see a headline that says: “A teenager invents a phone that charges in just 5 seconds!” It sounds exciting and unbelievable. Before clicking share, you decide to slow down and think.",
                    "You pause to reflect on how realistic it sounds, who posted it, and how it might affect others if shared. ",
                ],
                Images: []
            },
            {
                SlideLayout: "split_layout",
                SlideTitle: "",
                SlideContent: [
                    {
                        header:"",
                        text: "Hey team! Let’s kick this off. The internet is full of stuff—photos, videos, stories—but not all of it is true. Today, we’re going to figure out how to tell what’s real and what’s fake online.",
                    },
                    {
                        header: "Task:",
                        task: "Ask your group: Have you ever seen something online that turned out to be fake?"
                    }
                ],
                Images: []
            },
            {
                SlideLayout: "split_layout",
                SlideTitle: "",
                SlideContent: [
                    {
                        header:"Know This First",
                        text: "Hey team! Let’s kick this off. The internet is full of stuff—photos, videos, stories—but not all of it is true. Today, we’re going to figure out how to tell what’s real and what’s fake online.",
                    },
                    {
                        header: "Task:",
                        task: "Ask your group: Have you ever seen something online that turned out to be fake?"
                    }
                ],
                Images: []
            },
            {
                SlideLayout: "multi_column_layout",
                SlideTitle: "Instructions",
                SlideContent: [
                    {
                        number: "1",
                        heading: "Objective",
                        content: [
                            "It's your turn to act! In your group, you'll act out a scene about seeing something suspicious online.",
                            "Your job: Show how to spot red flags, think before sharing, and model smart choices."
                        ]
                    },
                    {
                        number: "2",
                        heading: "Group Roles",
                        content: [
                            "Choose your roles:",
                            [
                                "Poster – Shares the surprising or suspicious post",
                                "Friend 1 – Reacts and checks if it's true",
                                "Friend 2 – Helps decide what to do next",
                                "Narrator (optional) – Introduces the scene and wraps it up",
                                "Note Taker (optional) – Prepares to explain what the group learned"
                            ],
                            "Everyone helps create the story!"
                        ]
                    },
                    {
                        number: "3",
                        heading: "Choose a Scenario",
                        content: [
                            "Pick (or create) one of these scenes for your skit:",
                            [
                                "Poster – Shares the surprising or suspicious post",
                                "Friend 1 – Reacts and checks if it's true",
                                "Friend 2 – Helps decide what to do next",
                                "Narrator (optional) – Introduces the scene and wraps it up",
                                "Note Taker (optional) – Prepares to explain what the group learned"
                            ],
                            "Choose a setting (text chat, lunch table, group call) and build your story."
                        ]
                    },
                    {
                        number: "4",
                        heading: "What To Include In Your Scene",
                        content: [
                            "Poster – Shares the surprising or suspicious post",
                            "Friend 1 – Reacts and checks if it's true",
                            "Friend 2 – Helps decide what to do next",
                            "Narrator (optional) – Introduces the scene and wraps it up",
                            "Note Taker (optional) – Prepares to explain what the group learned"
                        ],
                    },
                    {
                        number: "5",
                        heading: "Plan Your Skit (5–7 minutes)",
                        content: [
                            "Each group will act out their scene.",
                            "After the skit, the group shares one thing they want the class to remember.",
                            [
                                "Poster – Shares the surprising or suspicious post",
                                "Friend 1 – Reacts and checks if it's true",
                                "Friend 2 – Helps decide what to do next",
                                "Narrator (optional) – Introduces the scene and wraps it up",
                                "Note Taker (optional) – Prepares to explain what the group learned"
                            ],
                            "Tip: Keep it real! Make it sound like how friends really talk online or in person"
                        ]
                    },
                    {
                        number: "6",
                        heading: "Time to Perform",
                        content: [
                            "It's your turn to act! In your group, you'll act out a scene about seeing something suspicious online.",
                            "Your job: Show how to spot red flags, think before sharing, and model smart choices.",
                            "Ready? Let’s go catch some fake news!"
                        ]
                    },

                ],
                Images: []
            }
        ]
    };

    const curriculumData = [
        {
            id: 1,
            title: "Module 1: Digital Footprint Fundamentals",
            units: [
                {
                    id: 1,
                    title: "Unit 1: Understanding Digital Footprints",
                    sessions: [
                        { id: 1, title: "Session 1: Define and Identify Digital Footprint Elements" },
                        { id: 2, title: "Session 2: Active vs Passive Footprints" }
                    ]
                },
                {
                    id: 2,
                    title: "Unit 2: Managing Your Online Presence",
                    sessions: [
                        { id: 3, title: "Session 1: Privacy Settings and Controls" },
                        { id: 4, title: "Session 2: Cleaning Your Digital Footprint" }
                    ]
                }
            ]
        },
        {
            id: 2,
            title: "Module 2: Advanced Digital Literacy",
            units: [
                {
                    id: 3,
                    title: "Unit 1: Critical Evaluation of Online Content",
                    sessions: [
                        { id: 5, title: "Session 1: Identifying Misinformation" },
                        { id: 6, title: "Session 2: Fact-Checking Techniques" }
                    ]
                }
            ]
        }
    ];

    const [currentSlide, setCurrentSlide] = useState(0);
    const [loading, setLoading] = useState(false);
    const profile = { themeColor: '#32BAF1' };
    const [showCatalogue, setShowCatalogue] = useState(false);
    const [completedSessions, setCompletedSessions] = useState([]);
    const [expandedModules, setExpandedModules] = useState({});

    const toggleCatalogue = () => {
        setShowCatalogue(!showCatalogue);
    };

    const toggleModule = (moduleId) => {
        setExpandedModules(prev => ({
            ...prev,
            [moduleId]: !prev[moduleId]
        }));
    };

    const isSessionCompleted = (sessionId) => {
        return completedSessions.includes(sessionId);
    };

    const nextSlide = () => {
        if (currentSlide < sessionData.slides.length - 1) {
            setCurrentSlide(currentSlide + 1);
        } else {
            const currentSessionId = 1;
            if (!completedSessions.includes(currentSessionId)) {
                setCompletedSessions([...completedSessions, currentSessionId]);
            }
        }
    };

    const prevSlide = () => {
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowRight') nextSlide();
            if (e.key === 'ArrowLeft') prevSlide();
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [currentSlide]);

    const renderSlideContent = () => {
        const slide = sessionData.slides[currentSlide];
        if (!slide) return null;

        const SlideComponent = PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT_VERBOSE[slide.SlideLayout];

        if (!SlideComponent) {
            console.error(`No component found for layout: ${slide.SlideLayout}`);
            return <div>Error: Slide layout not found</div>;
        }

        return (
            <SlideComponent
                title={slide.SlideTitle}
                slideContent={Array.isArray(slide.SlideContent) ? slide.SlideContent : [slide.SlideContent]}
                images={slide.Images || []}
            />
        );
    };

    const progress = ((currentSlide + 1) / sessionData.slides.length) * 100;
    const totalSlides = sessionData.slides.length;

    return (
        <div className="container">
            {/* new catalogue toggle button */}
            <div
                className="catalogue-toggle-button"
                onClick={toggleCatalogue}
                style={{ backgroundColor: getActiveThemeColor(profile) }}
            >
                <i className={`fa ${showCatalogue ? 'fa-times' : 'fa-list'}`}></i>
            </div>

            {/* new catalogue sidebar */}
            <div className={`catalogue-sidebar ${showCatalogue ? 'visible' : ''}`}>
                <div className="catalogue-header">
                    <h4>Learning Programs</h4>
                    <div className="close-catalogue" onClick={toggleCatalogue}>
                        <i className="fa fa-times"></i>
                    </div>
                </div>
                <div className={`catalogue-sidebar ${showCatalogue ? 'visible' : ''}`}>
                    <div className="catalogue-header">
                        <h3>Learning Programs</h3>
                    </div>
                    <div className="catalogue-items">
                        {curriculumData.map(module => (
                            <div key={module.id} className="catalogue-module">
                                <div
                                    className="module-title"
                                    onClick={() => toggleModule(module.id)}
                                >
                                    {module.title}
                                    <i className={`fa ${expandedModules[module.id] ? 'fa-angle-up' : 'fa-angle-down'}`}></i>
                                </div>
                                {expandedModules[module.id] && (
                                    <div className="module-content">
                                        {module.units.map(unit => (
                                            <div key={unit.id} className="catalogue-unit">
                                                <div className="unit-title">{unit.title}</div>
                                                <div className="unit-sessions">
                                                    {unit.sessions.map(session => (
                                                        <div
                                                            key={session.id}
                                                            className={`session-item ${isSessionCompleted(session.id) ? 'completed' : ''}`}
                                                        >
                                                            <div className="session-content">
                                                                <i className={`fa ${isSessionCompleted(session.id) ? 'fa-check-circle completed-icon' : 'fa-circle-o'}`}></i>
                                                                <span className={`session-title ${isSessionCompleted(session.id) ? 'completed-title' : ''}`}>
                                                                     {session.title}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="main-content">
                {loading ? (
                    <div className="loader-container">
                        <div className="loader"></div>
                    </div>
                ) : (
                    <>
                        <div className={'program-progress-container'}>
                            <div className={'program-progress-bar'}
                                 style={{ backgroundColor: getActiveThemeColor(profile), width: `${progress}%` }} />
                            <RazProgressSVG color={getActiveThemeColor(profile)} style={{ left: `${progress-6}%` }} />
                            <p>
                                <span style={{color: getActiveThemeColor(profile)}}>{currentSlide + 1}</span>
                                <span className={'slide-num-total'}>/{totalSlides}</span>
                            </p>
                        </div>

                        {renderSlideContent()}

                        <div style={{backgroundColor: getActiveThemeColor(profile)}}
                             className={'qt-next-btn'} onClick={nextSlide}>
                            <img className={'qt-next-btn-img'} src={right_arrow} alt="Next" />
                        </div>
                        <div style={{backgroundColor: getActiveThemeColor(profile)}}
                             className={'qt-prev-btn'} onClick={prevSlide}>
                            <img className={'qt-prev-btn-img'} src={left_arrow} alt="Previous" />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default withRouter(ProgramPreviewPage);
